<template>
  <main>
    <div class="banner">
      <mt-swipe :auto="4000">
        <mt-swipe-item v-for="v in banner" :key="v.url"><img :src="v.img" alt=""/></mt-swipe-item>
      </mt-swipe>
      <router-link tag="div" :to="{ name: 'search' }" class="search" for="search">
        <i class="icon-sousuo"></i>
        <input type="text" id="search" readonly placeholder="搜索目的地">
      </router-link>
    </div>
    <section class="country">
      <nav>
        <span :class="{on: i === countryIndex}" v-for="(v, i) in countryData" :key="v.id" @click="countryIndex = i">{{ v.text }}</span>
      </nav>
      <ul>
        <router-link :to="{name: 'list', query: { id: v.VisaCountryID }}" tag="li" v-for="v in countryData[countryIndex].country" :key="v.VisaCountryID">
          <figure><img :src="v.wechat_img" width="100%"></figure>
          <p><b>{{ v.Name }}</b><span><strong>{{ v.min_price }}</strong>起</span></p>
        </router-link>
      </ul>
    </section>
    <tabs></tabs>
  </main>
</template>

<script>
import Tabs from '@components/tab';
export default {
  components: {
    Tabs
  },
  data () {
    return {
      banner: [],
      countryIndex: 0,
      countryData: [{}],
    }
  },
  created () {
    this.$axios.get('home').then(res => {
      const { banner, countryData } = res;
      this.banner = banner;
      this.countryData = countryData;
    })
  },
  methods: {
  }
}
</script>

<style scoped src="./index.css"></style>